export default __webpack_public_path__ + "static/media/SpinnerWhite.d91d3c70.svg";